import React, { useEffect, useState } from 'react';
import Head from '../../../layout/head/Head';
import Content from '../../../layout/content/Content';
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Button, DataTableHead, DataTableItem, DataTableRow, Icon, PaginationComponent } from '../../../components/Component';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import AuthTenantLoader from '../../loaders/AuthTenantLoader';
import AuthTenantNoData from '../../error/AuthTenantNoData';
import AuthTenantPageError from '../../error/AuthTenantPageError';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { RETRIVE_TENANT_BUDGET_ALLOCATIONS_API } from '../../../api/api_data';
import * as app_consts from "../../../utils/app_consts";
import { fail_retrieve_tenant_budget_allocations, loading_retrieve_tenant_budget_allocations, reset_retrieve_tenant_budget_allocations, success_retrieve_tenant_budget_allocations } from '../../../reducers/auth_tenant/retrieve_tenant_budget_allocations_Slice';
import { RETRIEVE_TENANT_BUDGET_ALLOCATIONS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATIONS_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { formatNumber, formatToSentenceCase, messageToast } from '../../../utils/Utils';
import AddBudgetAllocationModal from '../../../components/modal/AddBudgetAllocationModal';
import moment from 'moment';
import { Badge } from 'reactstrap';

const BudgetAllocations = ({ tenant_info, user_info }) => {

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [page_data, setPageData] = useState([]);
  const [current_page_data, setCurrentPageData] = useState([]);
  const dispatch = useDispatch();
  const [sm, updateSm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemPerPage] = useState(10);
  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const [add_allocation_modal, setAddAllocationModal] = useState(false);

  // Get current list, pagination
  const indexOfLastItem = currentPage * itemPerPage;
  const indexOfFirstItem = indexOfLastItem - itemPerPage;
  const currentItems = current_page_data?.slice(indexOfFirstItem, indexOfLastItem);


  useEffect(() => {
    retrieve_budget_allocations();
  }, []);


  const retrieve_budget_allocations = () => {
    setError("");
    dispatch(tenant_auth_actions_helper(loading_retrieve_tenant_budget_allocations, success_retrieve_tenant_budget_allocations, fail_retrieve_tenant_budget_allocations, RETRIEVE_TENANT_BUDGET_ALLOCATIONS_ERROR_MSG, RETRIEVE_TENANT_BUDGET_ALLOCATIONS_SUCCESS_MSG, app_consts.GET, `/${tenant_info?.url_prefix}/${RETRIVE_TENANT_BUDGET_ALLOCATIONS_API}`));
  };

  // Listener
  const retrieve_tenant_budget_allocations_listener = useSelector((state) => state.retrieve_tenant_budget_allocations.retrieve_tenant_budget_allocations);

  useEffect(() => {
    if (retrieve_tenant_budget_allocations_listener.status !== app_consts.IDLE)
    {
      if (retrieve_tenant_budget_allocations_listener.status === app_consts.LOADING)
      {
        setLoading(true);
        setError("");
      } else
      {
        if (retrieve_tenant_budget_allocations_listener.status === app_consts.FAIL)
        {
          setLoading(false);
          setError(retrieve_tenant_budget_allocations_listener.message);
          messageToast(retrieve_tenant_budget_allocations_listener.message, app_consts.FAIL);
        } else if (retrieve_tenant_budget_allocations_listener.status === app_consts.SUCCESS)
        {
          setPageData(retrieve_tenant_budget_allocations_listener.data);
          setCurrentPageData(retrieve_tenant_budget_allocations_listener.data);
          const timer = setTimeout(() => {
            setLoading(false);
          }, 1000);

          return () => clearTimeout(timer); // cleanup in case the component unmounts
        }
        dispatch(reset_retrieve_tenant_budget_allocations());
      }
    }
  }, [retrieve_tenant_budget_allocations_listener]);

  const open_add_allocation_modal = () => {
    setAddAllocationModal(true);
  };

  const close_add_allocation_modal = () => {
    setAddAllocationModal(false);
  };

  const successAddBudgetAllocationFunction = () => {
    close_add_allocation_modal();
    retrieve_budget_allocations();
  };


  return (
    <>
      <Head title={tenant_info?.name ? `${tenant_info.name} Budget Allocations` : " Budget Allocations"} />
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page> Budget Allocations</BlockTitle>
              <BlockDes className="text-soft">
                <p>{!(loading || error) && ` Budget Allocations ${current_page_data?.length}`}</p>
              </BlockDes>
              {!(loading) && (
                <div className="mt-2">
                  <Link
                    onClick={(e) => {
                      e.preventDefault();
                      retrieve_budget_allocations();
                    }}
                  >
                    <Button color="light" outline className="bg-white d-none d-sm-inline-flex">
                      <span>Refresh List</span>
                    </Button>
                  </Link>
                </div>
              )}
            </BlockHeadContent>

            {
              !(loading || error) && (
                <>
                  <BlockHeadContent>
                    <div className="toggle-wrap nk-block-tools-toggle">
                      <a
                        href="#more"
                        className="btn btn-icon btn-trigger toggle-expand me-n1"
                        onClick={(ev) => {
                          ev.preventDefault();
                          updateSm(!sm);
                        }}
                      >
                        <Icon name="more-v"></Icon>
                      </a>
                      <div className="toggle-expand-content" style={{ display: sm ? "block" : "none" }}>
                        <ul className="nk-block-tools g-3">
                          <li>
                            <div className="form-control-wrap">
                              <div className="form-icon form-icon-right">
                                <Icon name="search"></Icon>
                              </div>
                              <input
                                type="text"
                                className="form-control"
                                id="default-04"
                                value={searchTerm}
                                onChange={e => setSearchTerm(e.target.value)}
                                placeholder="Search for Budget Allocation"
                              />
                            </div>
                          </li>
                          {
                            (user_info?.roles?.includes(app_consts.ADD_BUDGET_ALLOCATION) || user_info?.roles?.includes(app_consts.ADMINISTRATOR)) && (
                              <>
                                <li className="nk-block-tools-opt">
                                  <Button
                                    className="toggle btn-icon d-md-none"
                                    color="primary"
                                    onClick={() => {
                                      open_add_allocation_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                  <Button
                                    className="toggle d-none d-md-inline-flex"
                                    color="primary"
                                    onClick={() => {
                                      open_add_allocation_modal();
                                    }}
                                  >
                                    <Icon name="plus"></Icon>
                                    <span>Add Budget Allocation</span>
                                  </Button>
                                </li>
                              </>
                            )
                          }
                        </ul>
                      </div>
                    </div>
                  </BlockHeadContent>
                </>
              )
            }
          </BlockBetween>
        </BlockHead>
        {
          loading ?
            <>
              <AuthTenantLoader tenant_info={tenant_info} loading_message="Loading Budget Allocations..." />
            </>
            :
            <>
              {
                error ?
                  <>
                    <AuthTenantPageError tenant_info={tenant_info} error_message={error} />
                  </>
                  :
                  <>
                    {
                      page_data && page_data?.length > 0 ?
                        <>
                          <Block>
                            <div className="nk-tb-list is-separate is-medium mb-3">
                              <DataTableHead className="nk-tb-item">
                                <DataTableRow>
                                  <span className="sub-text">Name</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">Agency</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">Start Date</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">End Date</span>
                                </DataTableRow>
                                <DataTableRow size="lg">
                                  <span className="sub-text">Amount Allocated</span>
                                </DataTableRow>
                                <DataTableRow size="md">
                                  <span className="sub-text">Status</span>
                                </DataTableRow>
                                <DataTableRow>
                                  <span className="sub-text">Action</span>
                                </DataTableRow>
                              </DataTableHead>
                              {/*Head*/}
                              {currentItems.length > 0
                                ? currentItems.map((item) => (
                                  <DataTableItem key={item.id}>
                                    <DataTableRow>
                                      <Link to={`/${tenant_info.url_prefix}/budget_allocations/${item?.id}`}>
                                        <div className="user-card">
                                          <div className="user-info">
                                            <span className="tb-lead">
                                              {item?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                            </span>
                                          </div>
                                        </div>
                                      </Link>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span className="tb-lead">
                                            {item?.agency?.name || "--"}<span className="dot dot-success d-md-none ms-1"></span>
                                          </span>
                                        </div>
                                      </div>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <div className="user-info">
                                        <span className="tb-lead">{item?.start_date ? moment(item?.start_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                      </div>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <div className="user-info">
                                        <span className="tb-lead">{item?.end_date ? moment(item?.end_date).format("YYYY-MM-DD HH:mm:ss") : "--"}</span>
                                      </div>
                                    </DataTableRow>
                                    <DataTableRow>
                                      <div className="user-card">
                                        <div className="user-info">
                                          <span>{item?.value ? `${formatNumber(parseFloat(item?.value)?.toFixed(2))} ZMW` : "--"}</span>
                                        </div>
                                      </div>
                                    </DataTableRow>
                                    <DataTableRow size="md">
                                      <span className="tb-odr-status">
                                        <Badge
                                          color={
                                            item?.status === app_consts.ACTIVE
                                              ? "success"
                                              : "warning"
                                          }
                                          className="badge-dot"
                                        >
                                          {item?.status ? formatToSentenceCase(item?.status)?.toUpperCase() : "--"}
                                        </Badge>
                                      </span>
                                    </DataTableRow>
                                    <DataTableRow className="nk-tb-col-tools">
                                      <div className="tb-odr-btns d-none d-sm-inline">
                                        <Link to={`/${tenant_info.url_prefix}/budget_allocations/${item?.id}`}>
                                          <Button color="primary" size="sm" className="btn btn-dim">
                                            View
                                          </Button>
                                        </Link>
                                      </div>
                                      <Button className="btn-pd-auto d-sm-none">
                                        <Icon name="chevron-right"></Icon>
                                      </Button>
                                    </DataTableRow>
                                  </DataTableItem>
                                ))
                                : null}
                            </div>
                            {currentItems.length > 0 && (
                              <div className="mt-3">
                                <PaginationComponent
                                  itemPerPage={itemPerPage}
                                  totalItems={current_page_data?.length}
                                  paginate={paginate}
                                  currentPage={currentPage}
                                />
                              </div>
                            )}
                          </Block>
                        </>
                        :
                        <>
                          <AuthTenantNoData tenant_info={tenant_info} no_data_message={"No Budget Allocations Found"} />
                        </>
                    }
                    <AddBudgetAllocationModal isOpen={add_allocation_modal} successFunction={successAddBudgetAllocationFunction} closeModal={close_add_allocation_modal} tenant_info={tenant_info} user_info={user_info} />
                  </>
              }
            </>
        }
      </Content>
    </>
  );
};

export default BudgetAllocations;